import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaPlus, FaSearch, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import API_BASE_URL from '../../../../config/api';
import '../Nucleos/Nucleos.css';

const Nacionalidades = () => {
  const [nacionalidades, setNacionalidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    nacionalidade: '',
    ativo: true
  });
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadNacionalidades();
  }, []);

  const loadNacionalidades = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/nacionalidades`);
      if (!response.ok) {
        throw new Error('Erro ao buscar nacionalidades');
      }
      const data = await response.json();
      
      const formatadas = data.map(item => ({
        id: item.id_nacionalidade,
        nacionalidade: item.nome_nacionalidade,
        ativo: item.ativo
      }));
      
      setNacionalidades(formatadas);
      setLoading(false);
    } catch (error) {
      console.error('Erro ao carregar nacionalidades:', error);
      setLoading(false);
    }
  };

  const handleNew = () => {
    setFormData({
      id: '',
      nacionalidade: '',
      ativo: true
    });
    setIsEditing(false);
    setShowForm(true);
  };

  const handleEdit = (nacionalidade) => {
    setFormData({
      id: nacionalidade.id,
      nacionalidade: nacionalidade.nacionalidade,
      ativo: nacionalidade.ativo
    });
    setIsEditing(true);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta nacionalidade?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/nacionalidades/${id}`, {
          method: 'DELETE'
        });
        
        if (!response.ok) {
          throw new Error('Erro ao excluir nacionalidade');
        }
        
        loadNacionalidades();
      } catch (error) {
        console.error('Erro ao excluir nacionalidade:', error);
        alert('Erro ao excluir nacionalidade');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const url = isEditing 
        ? `${API_BASE_URL}/nacionalidades/${formData.id}`
        : `${API_BASE_URL}/nacionalidades`;
      
      const method = isEditing ? 'PUT' : 'POST';
      
      const payload = {
        nome_nacionalidade: formData.nacionalidade,
        ativo: formData.ativo
      };

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Erro ao salvar nacionalidade');
      }

      setShowForm(false);
      loadNacionalidades();
    } catch (error) {
      console.error('Erro ao salvar nacionalidade:', error);
      alert('Erro ao salvar nacionalidade');
    } finally {
      setSaving(false);
    }
  };

  const filteredNacionalidades = nacionalidades.filter(n =>
    n && String(n.nacionalidade || '').toLowerCase().includes((searchTerm || '').toLowerCase())
  );

  return (
    <div className="nucleos-container">
      {!showForm ? (
        <>
          <div className="tabela-header">
            <div className="header-content">
              <h1>Nacionalidades</h1>
            </div>
            <button className="btn-primary" onClick={handleNew}>
              <FaPlus /> Nova Nacionalidade
            </button>
          </div>

          <div className="table-container">
            <div className="table-controls">
              <div className="search-container">
                <FaSearch />
                <input
                  type="text"
                  placeholder="Buscar nacionalidade..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="table-info">
                {filteredNacionalidades.length} registros encontrados
              </div>
            </div>

            <div className="table-wrapper">
              <table className="data-table nucleos-table">
                <thead>
                  <tr>
                    <th className="col-id">ID</th>
                    <th className="col-nome">Nacionalidade</th>
                    <th className="col-status">Status</th>
                    <th className="col-acoes">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                        Carregando...
                      </td>
                    </tr>
                  ) : filteredNacionalidades.length === 0 ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                        Nenhum registro encontrado
                      </td>
                    </tr>
                  ) : (
                    filteredNacionalidades.map((nacionalidade) => (
                      <tr key={nacionalidade.id}>
                        <td>{nacionalidade.id}</td>
                        <td>{nacionalidade.nacionalidade}</td>
                        <td>
                          <span className={`status-badge ${nacionalidade.ativo ? 'ativo' : 'inativo'}`}>
                            {nacionalidade.ativo ? 'Ativo' : 'Inativo'}
                          </span>
                        </td>
                        <td className="col-acoes">
                          <div className="action-buttons">
                            <button 
                              className="btn-edit"
                              onClick={() => handleEdit(nacionalidade)}
                              title="Editar"
                            >
                              <FaEdit />
                            </button>
                            <button 
                              className="btn-delete"
                              onClick={() => handleDelete(nacionalidade.id)}
                              title="Excluir"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{isEditing ? 'Editar Nacionalidade' : 'Nova Nacionalidade'}</h2>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-content">
              <div className="form-group">
                <label htmlFor="nacionalidade">Nacionalidade *</label>
                <input
                  type="text"
                  id="nacionalidade"
                  className="form-control"
                  value={formData.nacionalidade}
                  onChange={(e) => setFormData({...formData, nacionalidade: e.target.value})}
                  required
                  maxLength={50}
                />
              </div>

              <div className="form-group">
                <Toggle
                  id="ativo"
                  label="Status:"
                  checked={formData.ativo}
                  onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                <FaSave /> {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Nacionalidades;

